export const localStorage = {
    getItem: function (key) {
        if (typeof window !== "undefined") {
            return window.localStorage.getItem(key)
        } else {
            return null
        }
    },
    setItem: function (key, value) {
        if (typeof window !== "undefined") {
            return window.localStorage.setItem(key, value)
        } else {
            return null
        }
    },
    removeItem: function (key) {
        if (typeof window !== "undefined") {
            return window.localStorage.removeItem(key)
        } else {
            return null
        }
    },
    clear: function () {
        if (typeof window !== "undefined") {
            return window.localStorage.clear()
        } else {
            return null
        }
    }
}